import { render, staticRenderFns } from "./LimitPageSelect.vue?vue&type=template&id=14e21378&scoped=true"
import script from "./LimitPageSelect.vue?vue&type=script&lang=js"
export * from "./LimitPageSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e21378",
  null
  
)

export default component.exports